
const locale = { 
  close:'new_publication_tour.close_btn',
  skip:'new_publication_tour.skip_btn',
  back:'new_publication_tour.back_btn',
  last:'new_publication_tour.last_btn',
  next:'new_publication_tour.next_btn'
}

export const GenerateArtSteps = [
  {
    target: '#input-image-prompt',
    content: 'new_publication_tour.step1',
    disableBeacon:true,
    placement:'top',
    locale,
    showSkipButton: true
  },
  {
    target: '#format-selector',
    content: 'new_publication_tour.step2',
    disableBeacon:true,
    placement:'left',
    locale,
    showSkipButton: true
  },
  {
    target: '#image-selector-button',
    content: 'new_publication_tour.step3',
    disableBeacon:true,
    placement:'bottom',
    locale,
    showSkipButton: true
  }
]
export const GenerateArtSteps2 = [
  {
    target: '#image-selector-reference',
    content: 'new_publication_tour.step4',
    disableBeacon:true,
    placement:'bottom',
    locale,
    showSkipButton: true
  }
]
export const GenerateArtSteps3 = [
  {
    target: '#image-selector',
    content: 'new_publication_tour.step5',
    disableBeacon:true,
    placement:'left',
    locale,
    showSkipButton: true
  }
]
export const GenerateArtSteps4 = [
  {
    target: '#image-selector-item',
    content: 'new_publication_tour.step6',
    disableBeacon:true,
    placement:'bottom',
    locale,
    showSkipButton: true
  }
]
export const GenerateArtSteps5 = [
  {
    target: '#generate-art-btn',
    content: 'new_publication_tour.step7',
    disableBeacon:true,
    placement:'auto',
    locale,
    showSkipButton: true
  }
]